import * as signalR from '@microsoft/signalr';

export class ChatHubClient {
  constructor() {
    this.connection = null;
    this.callbacks = {
      onMessage: null,
      onUserJoined: null,
      onUserLeft: null,
      onMessageEdited: null,
      onMessageDeleted: null,
      onUserTyping: null,
      onMentioned: null,
      onUserJoinedChannel:null,
      onUserLeftChannel:null,
      onUnreadMessage: null,
      onUnreadDirectMessage: null,
    };
  }

  async connect(token) {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl('https://2088.xn--p1ai/chatHub', {
        accessTokenFactory: () => token,
        withCredentials: true
      })
      .withAutomaticReconnect()
      .build();

    // Добавьте обработчики событий подключения
        this.connection.onclose((error) => {
            console.log('SignalR соединение закрыто:', error);
        });

        this.connection.onreconnecting((error) => {
            console.log('SignalR переподключение:', error);
        });

        this.connection.onreconnected((connectionId) => {
            console.log('SignalR переподключен:', connectionId);
            if (this.onReconnected) {
              this.onReconnected(connectionId);
            }
        });

    
    this.connection.on('ReceiveMessage', (message) => {
      if (this.callbacks.onMessage) {
        this.callbacks.onMessage(message);
      }
    });

    this.connection.on('UserJoined', (userId) => {
      if (this.callbacks.onUserJoined) {
        this.callbacks.onUserJoined(userId);
      }
    });

    this.connection.on('UserLeft', (userId) => {
      if (this.callbacks.onUserLeft) {
        this.callbacks.onUserLeft(userId);
      }
    });

    this.connection.on('MessageEdited', (message) => {
      if (this.callbacks.onMessageEdited) {
        this.callbacks.onMessageEdited(message);
      }
    });

    this.connection.on('MessageDeleted', (messageId) => {
      if (this.callbacks.onMessageDeleted) {
        this.callbacks.onMessageDeleted(messageId);
      }
    });

    this.connection.on('UserTyping', (username) => {
      if (this.callbacks.onUserTyping) {
        this.callbacks.onUserTyping(username);
      }
    });

    this.connection.on('Mentioned', (message) => {
      if (this.callbacks.onMentioned) {
        this.callbacks.onMentioned(message);
      }
    });

    this.connection.on('MessageReadBy', (message) => {
      if (this.callbacks.onMessageReadBy) {
        this.callbacks.onMessageReadBy(message);
      }
    });

    this.connection.on('UserJoinedChannel', (userId, username, avatarUrl, status, channelId, channelName) => {
      if (this.callbacks.onUserJoinedChannel) {
        this.callbacks.onUserJoinedChannel(userId, username, avatarUrl, status, channelId, channelName);
      }
    });

    this.connection.on('UserLeftChannel', (userId, channelId) => {
      if (this.callbacks.onUserLeftChannel) {
        this.callbacks.onUserLeftChannel(userId, channelId);
      }
    });

    this.connection.on('UnreadMessage', (channelId, siteId, message) => {
      if (this.callbacks.onUnreadMessage) {
          this.callbacks.onUnreadMessage(channelId, siteId, message);
      }
    });

    this.connection.on('UnreadDirectMessage', (channelId, senderId, senderName, senderAvatar, message) => {
      if (this.callbacks.onUnreadDirectMessage) {
          this.callbacks.onUnreadDirectMessage(channelId, senderId, senderName, senderAvatar, message);
      }
    });

     // Важно: ждем, пока соединение установится
     await this.connection.start();
     //console.log('✅ SignalR подключен!');
     return this.connection;
  }

  async joinChannel(channelId) {
    if (this.connection) {
      await this.connection.invoke('JoinChannel', channelId);
    }
  }

  async leaveChannel(channelId) {
    if (this.connection) {
      await this.connection.invoke('LeaveChannel', channelId);
    }
  }

  async sendMessage(channelId, content, mentionedUserIds = [], replyToMessageId = null) {
    if (this.connection) {
      await this.connection.invoke('SendMessage', channelId, content, mentionedUserIds, replyToMessageId);
    }
  }

  async sendAttachment(channelId, attachmentUrl, fileName, fileSize) {
    if (this.connection) {
      await this.connection.invoke('SendAttachment', channelId, attachmentUrl, fileName, fileSize);
    }
  }

  async editMessage(messageId, newContent) {
    if (this.connection) {
      await this.connection.invoke('EditMessage', messageId, newContent);
    }
  }

  async deleteMessage(messageId) {
    if (this.connection) {
      await this.connection.invoke('DeleteMessage', messageId);
    }
  }

  async typing(channelId) {
    if (this.connection) {
      await this.connection.invoke('Typing', channelId);
    }
  }

  async acknowledgeMessageDelivery(messageId) {
    if (this.connection) {
      await this.connection.invoke('AcknowledgeMessageDelivery', messageId);
    }
  }

  disconnect() {
    if (this.connection) {
      this.connection.stop();
    }
  }

  on(event, callback) {
    this.callbacks[event] = callback;
  }

  async sendMultipleAttachments(channelId, attachments, content = '') {
    if (this.connection) {
      await this.connection.invoke('SendMultipleAttachments', channelId, attachments, content);
    }
  }
  //Редактирование сообщений
  async editMessage(messageId, newContent) {
    if (this.connection) {
      await this.connection.invoke('EditMessage', messageId, newContent);
    }
  }
  
  async deleteMessage(messageId) {
    if (this.connection) {
      await this.connection.invoke('DeleteMessage', messageId);
    }
  }

  async addReaction(messageId, emoji) {
    if (this.connection) {
      await this.connection.invoke('AddReaction', messageId, emoji);
    }
  }
  
  async removeReaction(messageId, emoji) {
    if (this.connection) {
      await this.connection.invoke('RemoveReaction', messageId, emoji);
    }
  }

  async joinSite(siteId) {
    if (this.connection) {
        await this.connection.invoke('JoinSite', siteId);
    }
  }

  async leaveSite(siteId) {
    if (this.connection) {
        await this.connection.invoke('LeaveSite', siteId);
    }
  }

  async markChannelAsRead(channelId) {
    if (this.connection) {
        await this.connection.invoke('MarkChannelAsRead', channelId);
    }
  }
}

export const chatHub = new ChatHubClient();